import { FileText, UploadIcon, X } from "lucide-react";
import React from "react";

const UploadsGeneric = ({
  error,
  fileType,
  handleFileChange,
  selectedFile,
  removeFile,
  title,
  header,
  isMultiple = false,
  id,
}) => {
  function trimFilename(filename) {
    if (filename?.length > 30) {
      return (
        filename?.slice(0, 22) +
        "..." +
        filename?.split(".")?.[filename?.split(".")?.length - 1]
      );
    }
    return filename;
  }
  return (
    <div>
      <p className="text-sm text-gray-500 py-2">{title}</p>

      <div className="border border-dashed border-gray-300 rounded-lg p-4 text-center">
        <p className="px-4">
          <form>
            <label htmlFor={id} style={{ cursor: "pointer" }}>
              <UploadIcon className="w-6 h-6 mx-auto mb-2 text-gray-500" />
              <p className="text-sm font-medium mb-1 text-gray-500">{header}</p>
            </label>
            {fileType === "image" ? (
              <input
                id={id}
                type="file"
                multiple={isMultiple}
                accept="image/*"
                onInput={(e) => handleFileChange(e)}
                style={{ display: "none" }} // Hide the input
              />
            ) : (
              <input
                id={id}
                type="file"
                multiple={isMultiple}
                accept={`.${fileType}`}
                onInput={(e) => handleFileChange(e)}
                style={{ display: "none" }} // Hide the input
              />
            )}
          </form>
          {fileType === "image" ? (
            <p className="text-xs text-gray-400">
              Image must be in .jpg, .png, .heic and should be less than 5mb
            </p>
          ) : (
            <p className="text-xs text-gray-400">
              File must be in .{fileType} and should be less than 5mb
            </p>
          )}
        </p>
        {error && (
          <div className="bg-customError-100 ring-1 ring-customError-200 rounded-md p-3 mt-3">
            <p className="text-sm font-semibold text-customError-500">
              {error}
            </p>
          </div>
        )}
        {selectedFile?.length > 0 && (
          <div className="flex flex-col gap-3 pt-3">
            {selectedFile?.map((file, index) => {
              let name =
                file?.name?.split("/")?.[file?.name?.split("/")?.length - 1];
              return (
                <div className="flex items-center justify-between border border-dashed border-gray-300 rounded-lg p-3 gap-3">
                  <div className="flex gap-3">
                    <div className="w-12 max-w-12 rounded-lg flex items-center justify-center h-10">
                      {fileType === "image" ? (
                        <img
                          key={index}
                          src={file?.image ? file?.image : file?.url}
                          alt={`upload-${index}`}
                          className="w-12 max-w-12 rounded-lg object-contain h-10"
                        />
                      ) : (
                        <div className="w-12 max-w-12 rounded-lg object-contain h-10 flex justify-center items-center text-[#4592FD]">
                          <FileText />
                        </div>
                      )}
                    </div>
                    <div className="text-left">
                      <p className="font-medium text-sm truncate">
                        {trimFilename(name, file?.type)}
                      </p>
                      <p className="text-xs text-gray-500">
                        {(file?.size / (1024 * 1024)).toFixed(3)} MB
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => removeFile(name, index)}
                    className="text-customError-400 hover:text-customError-500 w-4"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadsGeneric;
